import { defineEvents, SHARED_EVENTS } from '@3plearning/mx-teacher-analytics';

const ASSIGNMENT = 'assignment';
const PREVIEW = 'preview';
const NAVIGATION = 'navigation';
const LEARNINGGAPS = 'learninggaps';
const FILTERS = 'filters';
const GRID = 'grid';

// The app event map. SHARED_EVENTS supplies the core group (page.view,
// page.time-on-page, section.error); each app event declares its feature group.
const appEvents = defineEvents({
  ...SHARED_EVENTS,
  'assignment.confirmation': { group: ASSIGNMENT, props: {} },
  'preview.quick': { group: PREVIEW, props: {} },
  'preview.assessment': { group: PREVIEW, props: {} },
  'navigation.go-to-new-assessments': { group: NAVIGATION, props: {} },
  'learninggaps.open': { group: LEARNINGGAPS, props: {} },
  'filter.course': { group: FILTERS, props: {} },
  'filter.assessment-type': { group: FILTERS, props: {} },
  'filter.class': { group: FILTERS, props: {} },
  'filter.group': { group: FILTERS, props: {} },
  'grid.checkbox-click': { group: GRID, props: {} },
  'grid.select-all': { group: GRID, props: {} }
});

export default appEvents;
